import TestarossaCampaign from './TestarossaCampaign'

export default TestarossaCampaign
// eslint-disable-next-line import/export
export * from './TestarossaCampaign'
